import { isDOM } from '@app/shared/predicates'

import { SfLog } from '@app/adapters/logger'
import SFetch from '@app/utils/sfetch'

export default (): void => {
  const unsubscribers: Array<() => void> = []

  window.onDomLoad(function ($dom) {
    if (isDOM($dom[0])) {
      unsubscribers.forEach((unsubscribe) => unsubscribe())

      const declineProposal = (): void => {
        const declineButton = $dom[0].querySelector(
          "[data-behavior='decline-reconciliation-proposal']"
        )

        if (!declineButton) {
          return
        }

        const data = extractDataFromElement(declineButton)

        if (!data.url) {
          return
        }

        try {
          SFetch.postFormRedirect({
            url: data.url,
            method: 'POST',
            authenticityToken: window.Silverfin.csrfToken(),
            data: [
              {
                key: 'block_proposals',
                value: data.proposalsBlocked.toString() || '',
              },
              { key: 'company_workflow_id', value: data.workflowId || '' },
            ],
          })
        } catch (e) {
          SfLog.warn('Failed to decline reconciliation proposal', {
            extra: {
              error: e,
            },
          })
        }
      }

      window.eventHub.$on('decline-reconciliation-proposal', declineProposal)
      unsubscribers.push(() =>
        window.eventHub.$off('decline-reconciliation-proposal', declineProposal)
      )
    }

    const acceptButton = $dom[0].querySelector(
      "[data-behavior='accept-reconciliation-proposal']"
    )

    if (acceptButton) {
      bindButton(acceptButton, 'confirm-accept-proposal-modal')
    }

    const declineButton = $dom[0].querySelector(
      "[data-behavior='decline-reconciliation-proposal']"
    )

    if (declineButton) {
      bindButton(declineButton, 'confirm-decline-proposal-modal')
    }
  })
}

function bindButton(
  el: Element,
  modalName: 'confirm-accept-proposal-modal' | 'confirm-decline-proposal-modal'
): void {
  el.addEventListener('click', (event) => {
    event.preventDefault()
    window.modalCitizen.openModal(modalName, extractDataFromElement(el))
  })
}

function extractDataFromElement(el: Element): {
  objName: string | null
  objType: string | null
  objReviewed: boolean
  objSource: string
  url: string | null
  workflowName: string | null
  showProposalBlocking: boolean
  proposalsBlocked: boolean
  workflowId: string | null
} {
  return {
    objName: el.getAttribute('data-obj-name'),
    objType: el.getAttribute('data-obj-type'),
    objReviewed: el.getAttribute('data-obj-reviewed') === 'true',
    objSource: el.getAttribute('data-obj-source') || 'manual',
    url: el.getAttribute('href'),
    workflowName: el.getAttribute('data-workflow-name'),
    showProposalBlocking:
      el.getAttribute('data-show-proposal-blocking') === 'true',
    proposalsBlocked: el.getAttribute('data-proposals-blocked') === 'true',
    workflowId: el.getAttribute('data-workflow-id'),
  }
}
